import React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";

const data = [
  { name: "Talleres o seminarios" },
  { name: "Reuniones" },
  { name: "Acontecimientos de empresa" },
  { name: "Congresos" },
  { name: "Ruedas de prensa" },
  { name: "Presentaciones" },
];

const Simultaneo = () => {
  return (
    <TableContainer component={Paper} sx={{ width: "auto" }}>
      <Typography
        variant="h6"
        align="center"
        sx={{ p: 2, background: "#009999", color: "#fff", width: "auto" }}
      >
        <b>Eventos que el equipo DLS traduce en simultáneo:</b>
      </Typography>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell align="center">
              <b>EVENTOS</b>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row, index) => (
            <TableRow key={index}>
              <TableCell align="center">{row.name}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default Simultaneo;
